/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowALeftIcon16Regular = forwardRef('ArrowALeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.574 12.392a.75.75 0 1 1-1.06 1.06L2.585 9.525a2.156 2.156 0 0 1 0-3.05l3.927-3.927a.75.75 0 1 1 1.06 1.06L3.934 7.25h9.352a.75.75 0 0 1 0 1.5H3.932l3.642 3.642Z" })));
});
